const cacheKeys = {
  all: ['network'],
  current: () => [...cacheKeys.all, 'current'],
  customizations: () => [...cacheKeys.current(), 'customizations'],
  customFields: () => [...cacheKeys.current(), 'customFields']
}

export default {
  endpoints: {
    networks: '/networks',
    networkId: (networkId) => `/networks/${networkId}`,
    customizations: (networkId) => `/networks/${networkId}/customizations`,
    customFields: (networkId) => `/networks/${networkId}/custom-fields`,
    modifyCustomFields: '/networks/custom-fields',
    leads: '/leads/networks',
    leadId: (id) => `/leads/networks/${id}`
  },
  cacheKeys
}
